import {
  ArrowLeftIcon_default
} from "./chunk-HIZR4ODA.mjs";
export {
  ArrowLeftIcon_default as default
};
